import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSharing: false,
};

const sharingSlice = createSlice({
  name: 'sharing',
  initialState,
  reducers: {
    isSharing: (state, action) => {
      state.isSharing = action.payload;
    },
  }
});

export const { isSharing } = sharingSlice.actions;
export default sharingSlice.reducer;

export const selectIsSharing = (state) => state.sharing.isSharing;